
  import { Vue, Component, Prop } from "vue-property-decorator";
  import badgeColor from "@/entities/BadgeColor";
  import EmployeeTagModal from "@/components/employee/EmployeeTagModalNew.vue";
  import TagIcon from "@/components/icons/TagIconNew.vue";
  import TagIconHover from "@/components/icons/TagIconHoverNew.vue";
  import { Tag } from "@/generated/graphql";
  import Badge from "@/components/common/Badge.vue";

  @Component({
    components: {
      TagIcon,
      EmployeeTagModal,
      TagIconHover,
      Badge,
    },
  })
  export default class EmployeeTag extends Vue {
    @Prop({ type: String, required: true }) readonly userUpdatedDate!: string;
    @Prop({ type: String, required: true }) readonly fullName!: string;
    @Prop({ type: String, required: true }) readonly initials!: string;
    @Prop({ type: Object, default: undefined }) readonly appliedTag?: Tag;
    @Prop({ type: Boolean, default: false }) readonly available!: boolean;
    @Prop({ type: String, default: undefined }) readonly avatar?: string;
    @Prop({ type: String, default: undefined }) readonly contractorId?: string;
    @Prop({ type: Boolean, default: false }) readonly defaultTagHidden!: boolean;
    @Prop({ type: String, default: undefined }) readonly iconClass?: string;

    modalShown: boolean = false;
    BadgeColor = badgeColor;
    isHovered: boolean = false;

    get tagShown(): boolean {
      return !this.defaultTagHidden;
    }

    onUpdateTag() {
      this.modalShown = false;
      this.$emit("tagUpdated");
    }
  }
